module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.dfd172f2.txt";